export type ProjectContextAction = {
  projectNumber: string;
};
export type LiveViewActionConfig = ProjectContextAction & {
  projectName: string;
  left: number;
  top: number;
};
export type ShowCreateDayIdCardDialog = ProjectContextAction;
export type ShowPrintDayIdCardDialog = ProjectContextAction;
export type ShowAssignDayIdCardDialog = ProjectContextAction;
export type ShowCreateVisitorIdCardDialog = ProjectContextAction;
export type ShowPrintVisitorIdCardDialog = ProjectContextAction;
export type ShowAssignVisitorIdCardDialog = ProjectContextAction;
export type ShowUnannouncedTransportAdviceDialog = ProjectContextAction;
export type ActionConfigMapping = {
  showLiveView: LiveViewActionConfig;
  showCreateDayIdCardDialog: ShowCreateDayIdCardDialog;
  showPrintDayIdCardDialog: ShowPrintDayIdCardDialog;
  showAssignDayIdCardDialog: ShowAssignDayIdCardDialog;
  showCreateVisitorIdCardDialog: ShowCreateVisitorIdCardDialog;
  showPrintVisitorIdCardDialog: ShowPrintVisitorIdCardDialog;
  showAssignVisitorIdCardDialog: ShowAssignVisitorIdCardDialog;
  showUnannouncedTransportAdviceDialog: ShowUnannouncedTransportAdviceDialog;
  scanValidMinimumWages: ProjectContextAction;
  createCustomerReport: never;
  createEmployeeReport: never;
};
// eslint-disable-next-line @tseslint/typedef
export const ExtjsActions = [
  "showLiveView",
  "showCreateDayIdCardDialog",
  "showPrintDayIdCardDialog",
  "showAssignDayIdCardDialog",
  "showCreateVisitorIdCardDialog",
  "showPrintVisitorIdCardDialog",
  "showAssignVisitorIdCardDialog",
  "showUnannouncedTransportAdviceDialog",
  "createCustomerReport",
  "createEmployeeReport",
  "scanValidMinimumWages"
] as const;
export type ActionConfig = {
  [K in keyof ActionConfigMapping]: {
    action: K;
    config?: ActionConfigMapping[K] | undefined;
  };
}[keyof ActionConfigMapping];
